export const columnTranslations: Record<string, string> = {
  id: "ID",
  supplier_name: "Forncedor",
  supplier_number: "Número",
  type: "Tipo",
  bussiness_unit: "Unidade de Negócio",
  cnpj: "CNPJ",
  is_active: "Ativo",
  created_at: "Criado Em",
  updated_at: "Atualizado Em",
  actions: "Ações",
  toggle: "Alterar Status",
};

export function formatCNPJ(value: string) {
  return value
    .replace(/\D/g, "")
    .replace(/^(\d{2})(\d)/, "$1.$2")
    .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
    .replace(/\.(\d{3})(\d)/, ".$1/$2")
    .replace(/(\d{4})(\d)/, "$1-$2")
    .slice(0, 18);
}
